import { getNativeContext } from '../helpers/get-native-context';
export const createMediaStreamTrackAudioSourceNodeConstructor = (createNativeMediaStreamTrackAudioSourceNode, createNotSupportedError, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) => {
    return class MediaStreamTrackAudioSourceNode extends noneAudioDestinationNodeConstructor {
        constructor(context, options) {
            const nativeContext = getNativeContext(context);
            if (isNativeOfflineAudioContext(nativeContext)) {
                throw createNotSupportedError();
            }
            const nativeMediaStreamTrackAudioSourceNode = createNativeMediaStreamTrackAudioSourceNode(nativeContext, options);
            super(context, 'active', nativeMediaStreamTrackAudioSourceNode, null);
        }
    };
};
//# sourceMappingURL=/build/es2018/factories/media-stream-track-audio-source-node-constructor.js.map